export const DangerousHtml = (props) => {
    const {children} = props;

    return <div dangerouslySetInnerHTML={{__html:children}}></div>
}